module.exports = __webpack_public_path__ + "img/solution-bg-boutique.d912a121.24673140.jpg";